import { Store } from '@/store/store.class'
import * as MapService from '@/services/map.service'
import { RouteGeometry, Place, Route, RouteLiveState, Location, LiveData, CoordinatesModel } from '@/api/tripply/models'
import { store } from '..'
import { GA } from '@/api/analytics'

interface MapState extends Object {
  loading: boolean;
  map: mapboxgl.Map | null;
  markers: MapService.MapMarkers;
  styleLoaded: boolean;
  driverMarker: mapboxgl.Marker | null;
}

class MapStore extends Store<MapState> {
  constructor() {
    super({
      name: 'maps',
      cached: false,
      state: {
        loading: true,
        map: null,
        markers: {},
        styleLoaded: false,
        driverMarker: null
      }
    })
  }

  getMap(): mapboxgl.Map | null { return this.state.map }

  SET_LOADING(loading: boolean) { 
    this.mutate(state => state.loading = loading)
  }
  SET_MAP(map: mapboxgl.Map) { 
    this.mutate(state => state.map = map)
  }
  SET_MARKERS(markers: MapService.MapMarkers) { 
    this.mutate(state => state.markers = markers)
  }

  async createMap(containerId: string, route: Route) {          
    const map = await MapService.createMap(containerId)
    map.on('click', async e => {   
      if (store.user.isOwner(route) && !route.live) {
        const coords = new CoordinatesModel(e.lngLat.lat, e.lngLat.lng)
        const location = await MapService.searchCoordinates(coords)
        store.route.addLocation(route.id, location)
        GA('add_place', { method: 'map_click', number: 1 })
      }
    })
    this.SET_MAP(map)    
    this.updatePlaces(route.places)    
    this.updateGeometry(route.geometry)
    this.SET_LOADING(false)
  }

  updatePlaces(places: Place[]) {   
    console.log('RECEIVED PALCES', places.length)
    
    if (this.state.map) {
      MapService.removeMarkers(this.state.markers)
      const newMarkers = MapService.drawPlaceMarkers(this.state.map, places)
      this.SET_MARKERS(newMarkers)
    }
  }
  updateGeometry(geometry: RouteGeometry, liveState?: RouteLiveState) {
    this.state.map && geometry && MapService.drawGeometry(this.state.map, geometry, liveState)
  }

  updateDriver(liveData: null | false | LiveData) {
    if (this.state.map && liveData) {
      MapService.updateMarkers(this.state.map, this.state.markers, liveData)

      if (this.state.driverMarker) {
        MapService.updateDriverMarker(this.state.driverMarker, liveData)
      } else {
        const driverMarker = MapService.createDriverMarker(this.state.map, liveData)
        driverMarker && this.mutate(state => state.driverMarker = driverMarker)
      }
    }
  }

  setLanguage(language: string) {
    this.state.map && MapService.setLanguage(this.state.map, language)
  }
  async setTheme(theme: string) {      
    return this.state.map && MapService.setTheme(this.state.map, theme)
  }

  zoom(change: number) {
    this.state.map && MapService.zoom(this.state.map, change)
  }

  terminate() {
    this.mutate(state => state.map = null)
  }

  togglePopup(placeId: string) {
    this.state.markers[placeId].togglePopup()
  }

  flyTo(location: Location, zoom?: number) {
    this.state.map && MapService.flyTo(this.state.map, location, zoom)
  }

  focus(place: Place) {
    this.flyTo(place)
    this.togglePopup(place.id)
  }


}
export const mapStore = new MapStore()